// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loaderClass":"_1zVsJ"};